module.exports = __webpack_public_path__ + "img/kerala_forest_hero_1.392f40a9.jpg";